export default __webpack_public_path__ + "static/media/graphics.58eaff03.png";